import React from 'react';
import { Colors, Icon, Input } from '@fourthwall/components';
import { ResetIcon, SearchIcon } from '@fourthwall/icons';
export const SearchBar = ({ value, ...props }) => (React.createElement(Input, { size: "small", leftIcon: SearchIcon, fullWidth: true, value: value, actionIcon: value?.length ? React.createElement(Icon, { component: ResetIcon, height: 18 }) : undefined, actionIconColor: Colors.GS1000, ...props }));
